import { AngularFirestore } from "angularfire2/firestore";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { versionFirebaseService } from "../firebase-service/firebase-service";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { NotificacionesService } from '../components/notificaciones.service';
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class GlobalServiceService {
  isLogged: BehaviorSubject<boolean>;
  menu: BehaviorSubject<any>;
  userInfo: BehaviorSubject<any>;
  menuGeneral: any;
  token;
  flagLogsData: boolean = false;
  // https://manteapi.kof.com.mx:8080
  // public base_url = localStorage.getItem("base_url");
  // public base_image_url = localStorage.getItem("base_image_url");
  // public base_cargas_masivas = localStorage.getItem("base_cargas_masivas");

  public base_url = 'https://storebackup.energetikamx.com';
  public base_image_url = 'https://storagelaplataformafemsatest.s3.amazonaws.com/';
  public base_cargas_masivas = 'https://storebackup.energetikamx.com';

  constructor(
    public afs: AngularFirestore,
    public versionFirebaseService: versionFirebaseService,
    private http: HttpClient,
  ) {
    this.get();
    this.isLogged = new BehaviorSubject(false);
    this.userInfo = new BehaviorSubject(
      JSON.parse(localStorage.getItem("userInfo"))
    );
    this.menu = new BehaviorSubject([
      {
        id: 3,
        name: "Dashboard",
        show: false,
        icon: "icon-screen-desktop menu-icon",
        childrens: null,
        route: "/dashboard",
      },
      {
        id: 2,
        name: "Mantenimientos",
        show: false,
        icon: "icon-wrench menu-icon",
        childrens: [
          {
            id: 1,
            name: "Dashboard",
            route: "/mantenimientos",
          },
          {
            id: 2,
            name: "Mantenimientos",
            route: "/mantenimientos/list",
          },
        ],
      },
      {
        id: 1,
        name: "Reportes",
        show: false,
        icon: "icon-calendar menu-icon",
        childrens: [
          {
            id: 1,
            name: "Dashboard",
            route: "/reportes",
          },
          {
            id: 2,
            name: "Reportes",
            route: "/reportes/list",
          },
        ],
      } /*,{
      id:9,
      name:'Behavior',
      show:false,
      icon:'icon-graph menu-icon',
      childrens:null,
      route:'/comportamiento'
    },{
      id:11,
      name:'Devices',
      show:false,
      icon:'icon-grid menu-icon',
      childrens:null,
      route:'/dispositivos'
    },{
      id:12,
      name:'Smart Alerts',
      show:false,
      icon:'icon-bell menu-icon',
      childrens:null,
      route:'/alertas'
    },{
      id:6,
      name:'Analysis',
      show:false,
      icon:'icon-chart menu-icon',
      childrens:null,
      route:'/analisis'
    },{
      id:8,
      name:'Admin Dashboard',
      show:false,
      icon:'icon-layers menu-icon',
      childrens:null,
      route:'/admin-dashboard'
    }*/,
      {
        id: 7,
        name: "Sitios",
        show: false,
        icon: "icon-map menu-icon",
        childrens: null,
        route: "/sitios",
      },
      {
        id: 10,
        name: "Admin usuarios",
        show: false,
        icon: "icon-people menu-icon",
        childrens: null,
        route: "/users",
      } /*,{
      id:13,
      name:'Proveedores',
      show:false,
      icon:'icon-briefcase menu-icon',
      childrens:null,
      route:'/proveedores'
    }*/,
      {
        id: 11,
        name: "Forecast",
        show: false,
        icon: "icon-briefcase menu-icon",
        childrens: null,
        route: "/forecast",
      },
      {
        id: 12,
        name: "Catálogos",
        show: false,
        icon: "icon-folder menu-icon",
        childrens: null,
        route: "/catalogos",
      },
      {
        id: 5,
        name: "Feedback",
        show: false,
        icon: "icon-support menu-icon",
        childrens: null,
        route: "/feedback",
      },
      {
        id: 13,
        name: "Refacciones",
        show: false,
        icon: "icon-wrench menu-icon",
        childrens: null,
        route: "/refacciones",
      },
      {
        id: 15,
        name: "Consultas",
        show: false,
        icon: "icon-wrench menu-icon",
        childrens: null,
        route: "/consultas",
      },
      {
        id: 16,
        name: "Administración",
        show: false,
        icon: "icon-wrench menu-icon",
        childrens: null,
        route: "/administracion",
      },
    ]);

    this.menuGeneral = [
      /*{
      id:3,
      name:'Dashboard',
      show:false,
      icon:'icon-screen-desktop menu-icon',
      childrens:null,
      route:'/dashboard'
    },*/ {
        id: 2,
        name: "Mantenimientos",
        show: false,
        icon: "icon-wrench menu-icon",
        childrens: [
          {
            id: 1,
            name: "Dashboard",
            route: "/mantenimientos",
          },
          {
            id: 2,
            name: "Mantenimientos",
            route: "/mantenimientos/list",
          },
        ],
      },
      {
        id: 1,
        name: "Reportes",
        show: false,
        icon: "icon-calendar menu-icon",
        childrens: [
          {
            id: 1,
            name: "Dashboard",
            route: "/reportes",
          },
          {
            id: 2,
            name: "Reportes",
            route: "/reportes/list",
          },
        ],
      } /*,{
      id:9,
      name:'Behavior',
      show:false,
      icon:'icon-graph menu-icon',
      childrens:null,
      route:'/comportamiento'
    },{
      id:11,
      name:'Devices',
      show:false,
      icon:'icon-grid menu-icon',
      childrens:null,
      route:'/dispositivos'
    },{
      id:12,
      name:'Smart Alerts',
      show:false,
      icon:'icon-bell menu-icon',
      childrens:null,
      route:'/alertas'
    },{
      id:6,
      name:'Analysis',
      show:false,
      icon:'icon-chart menu-icon',
      childrens:null,
      route:'/analisis'
    },{
      id:8,
      name:'Admin Dashboard',
      show:false,
      icon:'icon-layers menu-icon',
      childrens:null,
      route:'/admin-dashboard'
    }*/,
      {
        id: 7,
        name: "Sitios",
        show: false,
        icon: "icon-map menu-icon",
        childrens: null,
        route: "/sitios",
      },
      {
        id: 10,
        name: "Admin Usuarios",
        show: false,
        icon: "icon-people menu-icon",
        childrens: null,
        route: "/users",
      } /*,{
      id:13,
      name:'Proveedores',
      show:false,
      icon:'icon-briefcase menu-icon',
      childrens:null,
      route:'/proveedores'
    }*/,
      {
        id: 11,
        name: "Forecast",
        show: false,
        icon: "icon-briefcase menu-icon",
        childrens: null,
        route: "/forecast",
      },
      {
        id: 12,
        name: "Catalogos",
        show: false,
        icon: "icon-folder menu-icon",
        childrens: null,
        route: "/catalogos",
      },
      {
        id: 5,
        name: "FeedBack",
        show: false,
        icon: "icon-support menu-icon",
        childrens: null,
        route: "/feedback",
      },
      {
        id: 13,
        name: "Refacciones",
        show: false,
        icon: "icon-wrench menu-icon",
        childrens: null,
        route: "/refacciones",
      },
      {
        id: 15,
        name: "Consultas",
        show: false,
        icon: "icon-wrench menu-icon",
        childrens: null,
        route: "/consultas",
      },
      {
        id: 16,
        name: "Administración",
        show: false,
        icon: "icon-wrench menu-icon",
        childrens: null,
        route: "/administracion",
      },
    ];
  }

  get() {
    this.versionFirebaseService.getTypeBase().subscribe((data: any) => {
      // localStorage.setItem("base_url", data.base_url);
      // localStorage.setItem("base_image_url", data.base_image_url);
      // localStorage.setItem("base_cargas_masivas", data.base_cargas_masivas);
      // this.base_url = data.base_url;
    });
  }

  get menuList(): any | Observable<any> {
    return this.menu.asObservable();
  }

  get logged(): any | Observable<any> {
    return this.isLogged.asObservable();
  }

  setLogged(value) {
    this.isLogged.next(value);
  }

  setMenu(value) {
    this.menu.next(value);
  }

  valueMenu() {
    return this.menu.value;
  }

  valueMenuGral() {
    return this.menuGeneral;
  }

  get userInfoData(): any | Observable<any> {
    return this.userInfo.asObservable();
  }

  setUserInfo(value) {
    this.userInfo.next(value);
  }
  getUserInfo() {
    return this.userInfo.value;
  }

  getUser(userId) {
    return this.afs.collection("users").doc(userId).valueChanges();
  }

  flagLogs() {
    return this.afs.collection("globals").valueChanges();
  }

  logs(msg) {
    if (this.flagLogsData) {
      console.log(msg);
    }
  }

  tracking(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.post(
      this.base_url + `/users/tracking`,
      data,
      httpOptions
    );
  }

  getTracking() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.get(
      this.base_url + `/users/tracking`,
      httpOptions
    );
  }

  public reportsCargaInspeccion(data: any, id) {}

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf("edge") > -1:
        return "Edge";
      case agent.indexOf("opr") > -1 && !!(<any>window).opr:
        return "Opera";
      case agent.indexOf("chrome") > -1 && !!(<any>window).chrome:
        return "Chrome";
      case agent.indexOf("trident") > -1:
        return "ie";
      case agent.indexOf("firefox") > -1:
        return "Firefox";
      case agent.indexOf("safari") > -1:
        return "Safari";
      default:
        return "other";
    }
  }
}
